import { cn } from '@/lib/utils'

/**
 * Reachability indicator for a person. Phone numbers are deliberately never
 * rendered in the UI — the only thing a sender needs to know is whether the
 * person can receive a text, so we show that as green / amber instead.
 */
export function MobileStatus({
  hasMobile,
  className,
}: {
  hasMobile: boolean
  className?: string
}) {
  return (
    <span
      className={cn(
        'flex items-center gap-1.5 font-semibold',
        hasMobile ? 'text-sage-ink' : 'text-warn-ink',
        className,
      )}
    >
      <span
        className={cn('h-1.5 w-1.5 flex-none rounded-full', hasMobile ? 'bg-sage' : 'bg-warn-ink')}
      />
      {hasMobile ? 'Mobile on file' : 'No mobile on file'}
    </span>
  )
}
